import React, { useState } from 'react';
import { useAlgoliaDataContext } from '../../hooks/useAlgoliaDataContext';
import { InputSearch } from './Input.search';
import { ButtonListItem } from './Button.listItem';
import { ButtonExpandValuesList } from './Button.expandValuesList';
import { useFacetLogic } from '../../hooks/useFacetLogic';
const Items = ({ fConfig, items, activeValues, itemClickHandler }) => {
    const [searchValue, setSearchValue] = useState('');
    const [listExpanded, setListExpanded] = useState(false);
    let visibleItemsCount = 0;
    return React.createElement(React.Fragment, null,
        fConfig.searchable === true &&
            React.createElement(InputSearch, { name: fConfig.name, value: searchValue, setValue: (value) => { setSearchValue(value); } }),
        React.createElement("ul", { className: "list:none" }, (() => {
            const itemElements = [];
            const searchValueLower = searchValue.toLowerCase();
            const nbItemsInShortList = fConfig.shortList ?? 0;
            for (const { label, value, count } of items) {
                if (fConfig.searchable === true &&
                    searchValueLower.length > 0 &&
                    !value.includes(searchValueLower))
                    continue;
                if (nbItemsInShortList > 0 &&
                    !listExpanded &&
                    nbItemsInShortList === visibleItemsCount)
                    break;
                visibleItemsCount++;
                itemElements.push(React.createElement("li", { className: "pos:r", key: value },
                    React.createElement(ButtonListItem, { fConfig: fConfig, fKey: fConfig.key, label: label, value: value, count: count, activeValues: activeValues, itemClickHandler: itemClickHandler, textForHighlight: fConfig.searchable !== undefined ? searchValue : undefined })));
            }
            return itemElements;
        })()),
        fConfig.shortList !== undefined &&
            visibleItemsCount >= fConfig.shortList &&
            items.length > fConfig.shortList &&
            React.createElement(ButtonExpandValuesList, { expanded: listExpanded, onClick: () => { setListExpanded(!listExpanded); } }));
};
export const ItemsList = ({ fConfig }) => {
    const { facets } = useAlgoliaDataContext();
    const [activeValues, itemClickHandler] = useFacetLogic(fConfig.key, fConfig.singleSelect);
    return React.createElement(Items, { items: facets[fConfig.key], fConfig: fConfig, activeValues: activeValues, itemClickHandler: itemClickHandler });
};
